import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { FlightShopActions } from "@b2bportal/core-flights";
import {
  PackageNavigationFlow,
  PackageSteps,
  PageRouteContainer,
} from "@b2bportal/core-utilities";
import {
  PackagesFlightSlotProvider,
  usePackageFlightDeparturePageRoute,
} from "@tenant/packages";
import { usePackageFlightDeparturePage } from "./hooks/usePackageFlightDeparturePage";
import { PackageFlightDeparturePage } from "./PackageFlightDeparturePage";

export const PackageFlightDeparturePageRoute = () => {
  const dispatch = useDispatch();

  const { fullRouteWithCurrentQueryParams } =
    PackageNavigationFlow.useGetStepRoute(PackageSteps.FLIGHT_DEPARTURE);

  // Mirrors the non-packages DeparturePageRoute: reset to 0 (outbound) so
  // coming back from the return page - or in from a non-packages return page -
  // doesn't leave the departure cards rendering the return slice.
  useEffect(() => {
    dispatch(FlightShopActions.setMulticityShopStep(0));
  }, [dispatch]);

  return (
    <PackagesFlightSlotProvider>
      <PageRouteContainer
        route={{
          useValidateRouteProps: usePackageFlightDeparturePageRoute,
          errorRedirectPath: fullRouteWithCurrentQueryParams,
        }}
        container={{
          useDeriveViewProps: usePackageFlightDeparturePage,
          Component: PackageFlightDeparturePage,
        }}
      />
    </PackagesFlightSlotProvider>
  );
};
